import * as React from 'react';
import BrowsingHistoryServiceInstance from '../../services/products/BrowsingHistoryService';
import listService from 'src/services/lists/ListsService';
import './BrowsingHistoryProductsCarousel.scss';
import Button from '../common/Button';

import ProductModel from '../../model/product.model';
import ProductCard from '../ProductCard/ProductCard';
import CarouselContainer from '../common/CarouselContainer';
import {
  goToBrowsingHistoryProducts,
  ifLoggedIn,
  goToPartDetail
} from 'src/utils/navigation';
import i18n from 'src/translation/i18n';
import exploreSmall from '../../assets/explore-small';
import env from 'src/shared/env';
import { analyticsListNames } from 'src/analytics/constant';
import { HalfCircleSpinner } from 'react-epic-spinners';
import { Redirect } from 'react-router-dom';

interface IBrowsingHistoryProductsCarouselState {
  isLoading: boolean;
  isFavoriteLoading: boolean;
  selectedFavoriteItem: string;
  products: ProductModel[];
}

export class BrowsingHistoryProductsCarousel extends React.Component<
  any,
  IBrowsingHistoryProductsCarouselState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      isLoading: true,
      isFavoriteLoading: true,
      selectedFavoriteItem: '',
      products: []
    };
  }
  public handleBuyNow = (productId: string) => {
    const productClicked = this.state.products.find(
      product =>
        `${product.manufacturerCode}  ${product.productNumber}` === productId
    );
    productClicked['position'] =
      this.state.products.indexOf(productClicked) + 1;
    this.props.fireProductClickEvent({
      product: productClicked,
      list: analyticsListNames.BROWSING_HISTORY
    });
    ifLoggedIn(() => goToPartDetail(productId));
  };
  private getProducts = () => {
    BrowsingHistoryServiceInstance.getProducts().then(res => {
      this.setState({
        isLoading: false,
        isFavoriteLoading: false,
        selectedFavoriteItem:'',
        products: res
      });
      this.props.fireProductImpressionEvent({
        products: res,
        list: analyticsListNames.BROWSING_HISTORY
      });
    });
  };
  private handleToggleFavorite = (
    name: string,
    category: string,
    mfc: string,
    favorite: boolean,
    favoriteId: number
  ) => { 
    if (favorite) {
      this.setState({ isFavoriteLoading: true,selectedFavoriteItem: name }); // Start loading
      listService.deleteItem(favoriteId).then(res => this.getProducts());
    } else {    
      if(category?.trim() === "WSER") {
        goToPartDetail(`${mfc}  ${name}`);
        return;
      }      
      this.setState({ isFavoriteLoading: true,selectedFavoriteItem: name }); 
      listService
        .addItem('favorites', name, mfc)
        .then(res => this.getProducts())
        .catch(error => {
          console.error("Failed to add item:", error);
          this.setState({ isFavoriteLoading: false }); // End loading in case of error
        });
    }
  };

  private reloadList = () => {
    this.getProducts();
  };

  private viewAll = () => {
    goToBrowsingHistoryProducts();
  };

  public componentDidMount() {
    this.getProducts();
  }

  public render() {
    return ifLoggedIn && this.state.isLoading ? (
      <div className="rp-text-container-no-data text-center">
        <HalfCircleSpinner
          color="#0b4da2"
          size={60}
          style={{
            textAlign: 'center',
            display: 'inline-block'
          }}
        />
        <p className="rp-no-data-desc">Loading...</p>
      </div>
    ) : (
      <div className="rp-browsing-history-products-carousel">
        <div
          className={
            this.state.products.length < 4
              ? 'rp-browsing-text'
              : 'browsing-text'
          }
        >
          {i18n.t('common.browsingHistory')}
        </div>
        <div>
          {this.state.products.length > 1 ? (
            <Button
              buttonClass="rp-recent-orders--button"
              label={i18n.t('recentOrders.viewAll')}
              action={this.viewAll}
            />
          ) : (
            <span />
          )}
        </div>
        {this.state.products.length > 0 ? (
          <CarouselContainer loading={this.state.isLoading}>
            {this.state.products.map((product, index) => (
              <ProductCard
                key={index}
                part={product}
                id={product.productNumber}
                name={product.productNumber}
                category={product.category}
                mfc={product.manufacturerCode}
                description={product.description}
                price={product.partnerPrice}
                msrp={product.retailPrice}
                image={product.imageUrls !== null ? product.imageUrls[0] : ''}
                handleOnClicBuyNow={this.handleBuyNow}
                handleToggleFavorite={this.handleToggleFavorite}
                inStock={product.inStock}
                isFavoriteLoading = {this.state.isFavoriteLoading}
                selectedFavoriteItem = {this.state.selectedFavoriteItem}
                favorite={product.favorite}
                favoriteId={product.idFavoriteItem}
                deal={!!product.discountInfo}
                state={product.state}
                stateDescription={product.stateDescription}
                reloadPart={this.reloadList}
              />
            ))}
          </CarouselContainer>
        ) : (
          // <p className="rp-browsing-history-products-carousel--empty">
          //   {i18n.t('common.startExploring')}
          // </p>
          <div className="rp-no-data-container-main rp-browsing-no-data-container">
            <div className="rp-no-data-container">
              <div className="rp-no-data-text">
                <div className="rp-text-container-no-data">
                  <p className="rp-no-data-desc">
                    {i18n.t('common.noBrowsingHistoryData')}
                  </p>
                </div>
              </div>
              <div className="rp-no-data-image-container">
                <img
                  className={
                    env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                      ? 'rp-no-data-img rp-no-data-img-CA'
                      : 'rp-no-data-img'
                  }
                  src={exploreSmall}
                  alt=""
                />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default BrowsingHistoryProductsCarousel;
